import { V1Intellectual } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Intellectual, Opportunity> = {
    teacherWorldviewTraining: {
        title: "Teacher Worldview Training",
        prologue:
            "The school trains teachers in their biblical worldview and evaluates their growth (Ezra 7:10; Romans 12:1-2; Colossians 3:10-11).",
    },
    integratingFaithAndTeaching: {
        title: "Integrating Faith and Teaching",
        prologue:
            "Teachers study how to integrate faith with their academic discipline and receive appropriate training (Romans 12:1-2; 1 Corinthians 11:1; 1 John 2:6).",
    },
    integratingFaithAndLearning: {
        title: "Integrating Faith and Learning",
        prologue:
            "Students see how their academic work helps them better understand God’s character and the Bible’s teachings (Philippians 2:5; 1 Corinthians 2:14-16; Romans 8:6-7; Matthew 12:25, 30).",
    },
    spiritualGuidance: {
        title: "Spiritual Guidance",
        prologue:
            "School personnel are open to guiding students with their questions and doubts about the Christian faith, and alumni recall the school providing a safe environment for questions (Acts 8:26-40; Luke 24:38; Jude 22).",
    },
    faithBasedAccreditation: {
        title: "Faith-Based Accreditation",
        prologue:
            "Board members see the value of the accreditation process in aligning the school with its Christian mission (Philippians 1:10; 1 Timothy 4:15; Colossians 3:10-11, 23; Hebrews 11:1; Luke 18:27).",
    },
    distinctivelyChristianEducation: {
        title: "Distinctively Christian Education",
        prologue:
            "Board members feel Christian education must be distinct in both content and pedagogy (2 Timothy 1:13, 3:16- 17).",
    },
};
